/* eslint-disable react-hooks/exhaustive-deps */
import './mutualform.scss'
import styleds from 'styled-components'
import './mutualform.scss'
import { Box } from '@mui/system'
import { useState, useEffect } from 'react'
import Box1 from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { StyledSlider } from './styledUtil/util'
import Chart from 'chart.js/auto'
import { CategoryScale } from 'chart.js'
import { Pie } from 'react-chartjs-2'

Chart.register(CategoryScale)

const initialState = {
  sipAmount: 0,
  returns: 1,
  invest: 1
}

export default function MutualForm () {
  const [slideCount, setSlideCount] = useState(initialState)
  const [interestResult, setInteresetResult] = useState(0)
  const [totalInvest, setTotalInveset] = useState(0)
  const [estReturn, setEstReturn] = useState(0)
  //   const [chartData, setchartData] = useState({})

  useEffect(() => {
    myCal()
  }, [slideCount])

  const handleChange = e => {
    const { name, value } = e.target
    if (
      Number(slideCount.sipAmount) >= 500000 ||
      Number(slideCount.returns) >= 50 ||
      Number(slideCount.invest) >= 50
    ) {
      setSlideCount({
        ...slideCount,
        [name]: 0
      })
    } else {
      setSlideCount({
        ...slideCount,
        [name]: value
      })
    }
  }

  const myCal = () => {
    // e.preventDefault()
    const { sipAmount, returns, invest } = slideCount
    console.log(sipAmount)
    const amount = Number(sipAmount)
    const interest = Number(returns)
    const years = Number(invest)
    const freq = 1

    var instalment_amount = amount
    var no_of_compounding_periods = (12 / freq) * years
    var int_rate_per_period = interest / (12 / freq) / 100
    var total_amount_invested = years * instalment_amount * 12
    var expected_amount_on_maturity =
      instalment_amount *
      ((Math.pow(1 + int_rate_per_period, no_of_compounding_periods) - 1) /
        int_rate_per_period) *
      (1 + int_rate_per_period)
    var estimatedReturn = expected_amount_on_maturity - total_amount_invested

    const result = expected_amount_on_maturity
    const myData = result.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR'
    })
    const totalResult = total_amount_invested.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR'
    })

    const estMateReturn = estimatedReturn.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR'
    })
    setInteresetResult(myData)
    setTotalInveset(totalResult)
    setEstReturn(estMateReturn)
  }

  const data = {
    labels: ['Principal', 'Return %', 'Years'],
    datasets: [
      {
        label: 'SIP Calculator',
        fill: false,
        lineTension: 0.1,
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)'
        ],
        borderColor: 'rgba(75,192,192,1)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [
          slideCount.sipAmount / 100,
          slideCount.returns,
          slideCount.invest
        ]
      }
    ]
  }

  //   const testChange = (e) => {
  //       setHello(e.target.value)
  //   }

  console.log(interestResult)

  return (
    <>
      <div className='mutualform-container'>
        <div>
          <div className='heading'>
            <Title>SIP Calculator</Title>
            <Content>
              Find the future value of your monthly/quarterly SIP investment.
            </Content>
          </div>
          <div className='main-content'>
            {/* sip amount */}
            <div className='sip-split'>
              <div>
                <h3>SIP Amount</h3>
                <label>Upto 5Lac</label>
                <Box sx={{ width: 300 }}>
                  <StyledSlider
                    max={500000}
                    value={slideCount.sipAmount}
                    name='sipAmount'
                    onChange={handleChange}
                  />
                </Box>
              </div>
              <div>
                <Box1
                  component='form'
                  sx={{
                    '& > :not(style)': { m: 1, width: '25ch' }
                  }}
                  noValidate
                  autoComplete='off'
                >
                  <TextField
                    id='outlined-basic'
                    label='SIP Amount'
                    variant='outlined'
                    value={slideCount.sipAmount}
                    name='sipAmount'
                    onChange={handleChange}
                  />
                </Box1>
              </div>
            </div>
            {/* sip amount */}

            {/* interest */}
            <div className='sip-split'>
              <div>
                <h3>Expected Rate of Return (p.a.)</h3>
                <label>Upto 50%</label>
                <Box sx={{ width: 300 }}>
                  <StyledSlider
                    max={50}
                    value={slideCount.returns}
                    name='returns'
                    onChange={handleChange}
                  />
                </Box>
              </div>
              <div>
                <Box1
                  component='form'
                  sx={{
                    '& > :not(style)': { m: 1, width: '25ch' }
                  }}
                  noValidate
                  autoComplete='off'
                >
                  <TextField
                    id='outlined-basic'
                    label='Rate of Return'
                    variant='outlined'
                    value={slideCount.returns}
                    name='returns'
                    onChange={handleChange}
                  />
                </Box1>
              </div>
            </div>
            {/* interest */}

            {/* years */}
            <div className='sip-split'>
              <div>
                <h3>Investment Duration</h3>
                <label>Upto 50 years</label>
                <Box sx={{ width: 300 }}>
                  <StyledSlider
                    max={50}
                    value={slideCount.invest}
                    name='invest'
                    onChange={handleChange}
                  />
                </Box>
              </div>
              <div>
                <Box1
                  component='form'
                  sx={{
                    '& > :not(style)': { m: 1, width: '25ch' }
                  }}
                  noValidate
                  autoComplete='off'
                >
                  <TextField
                    id='outlined-basic'
                    label='Duration'
                    variant='outlined'
                    value={slideCount.invest}
                    name='invest'
                    onChange={handleChange}
                  />
                </Box1>
              </div>
            </div>
            {/* years */}
            <p>
              Your Investments <b>{totalInvest}</b>
            </p>
            <p>
              Your Estimated Returns <b>{estReturn}</b>
            </p>
            <p>
              The future value of your SIP investment is <b>{interestResult}</b>
            </p>
          </div>
        </div>
        <div>
          <Pie data={data} />
        </div>
      </div>
    </>
  )
}

const Title = styleds.h2`
  letter-spacing: 2px;
  text-transform: capitalize;
`

const Content = styleds.h4`
  letter-spacing: 1.6px;
  text-transform: capitalize;
`
